import { HStack, Box } from "@whoosh/design-system/src/components/primitive";

import { useFlags } from "../../../../../../../../../../../../utils/launchDarkly";
import { BillMemberDisplay } from "./BillMemberDisplay";
import { GuestPlayerRateDisplay } from "./GuestPlayerRateDisplay";
import { HostingMemberDisplay } from "./HostingMemberDisplay";

type Props = {
  roundId: string;
  membershipTypeId: string | undefined;
  nonPlayingHost: boolean;
  hostId: string;
};

export const GuestRoundHostRateDisplay = ({
  roundId,
  membershipTypeId,
  nonPlayingHost,
  hostId,
}: Props) => {
  const { memberBillGuestToggle } = useFlags();

  return (
    <HStack justifyContent="space-between" alignItems="center" flex={1}>
      <Box gap={".5"}>
        <HostingMemberDisplay hostId={hostId} />
      </Box>

      <Box gap={".5"}>
        <GuestPlayerRateDisplay
          membershipTypeId={membershipTypeId}
          nonPlayingHost={nonPlayingHost}
          roundId={roundId}
        />
      </Box>
      {memberBillGuestToggle ? (
        <Box gap={".5"}>
          <BillMemberDisplay roundId={roundId} />
        </Box>
      ) : (
        <Box />
      )}
    </HStack>
  );
};
